export const isIOSDevice = () => {
  if (typeof window === 'undefined') return false;
  const userAgent = window.navigator.userAgent;
  return (
    !!userAgent.match(/iP(ad|hone|od)/i) &&
    !!userAgent.match(/WebKit/i) &&
    !userAgent.match(/CriOS/i)
  );
};
